import { NgModule } from '@angular/core';
import { SnackbarStoreModule } from './store/snackbar-store.module';

@NgModule({
  imports: [SnackbarStoreModule],
})
export class MainSnackbarDataAccessModule {}
